import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { SERVICE_DATA } from "@/data/services";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <section className="pt-28 pb-12 sm:pt-36 sm:pb-16 md:pt-40 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-gold text-sm tracking-[0.3em] uppercase font-semibold mb-4">
            Our Services
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="font-heading text-4xl sm:text-5xl md:text-7xl font-bold tracking-tighter uppercase text-white mb-6">
            Complete Signage <span className="gold-shimmer">Solutions</span>
          </motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} className="text-sm sm:text-base text-white/50 max-w-2xl leading-relaxed">
            From design to installation, we provide end-to-end signage services that help your business stand out in Vancouver and beyond.
          </motion.p>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5 lg:gap-6">
            {SERVICE_DATA.map((service, i) => (
              <motion.div
                key={service.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
              >
                <Link
                  to={`/services/${service.slug}`}
                  className="group relative block rounded-xl sm:rounded-2xl overflow-hidden aspect-square"
                  data-testid={`all-service-card-${i}`}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5">
                    <h3 className="font-heading text-xs sm:text-sm lg:text-base font-bold text-white group-hover:text-gold transition-colors">{service.title}</h3>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-28 relative overflow-hidden">
        <div className="absolute inset-0 bg-gold/5"></div>
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(255,191,0,0.4)] to-transparent"></div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 md:px-12 text-center">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white mb-6">
            Ready to Make Your Business <span className="gold-shimmer">Shine?</span>
          </h2>
          <p className="text-white/50 text-sm sm:text-base mb-10 max-w-2xl mx-auto">
            Get a free consultation and discover how our custom signage solutions can transform your business visibility.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/booking" className="bg-gold text-black font-bold px-8 sm:px-10 py-4 rounded-full hover:shadow-[0_0_20px_rgba(255,191,0,0.4)] transition-all duration-300 hover:-translate-y-1 flex items-center gap-2 text-sm sm:text-base">
              Book Free Consultation <ArrowRight className="w-4 h-4" />
            </Link>
            <a href="tel:+17783220801" className="bg-transparent border border-white/20 text-white px-8 sm:px-10 py-4 rounded-full hover:bg-white/5 hover:border-gold/50 transition-all flex items-center gap-2 text-sm sm:text-base">
              <Phone className="w-4 h-4" /> (778) 322-0801
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
